import NotificationsIcon from '@mui/icons-material/Notifications'
import { Badge, Box, CircularProgress, IconButton, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { useUpdateNotifyItems } from '../../../api/aws/notifications/useUpdateNotifyItems'
import { useUserNotifications } from '../../../context/NotificationProvider/useUserNotifications'
import NotificationDrawer from '../../Notifications/NotificationDrawer'

type Markable = { PK: string; SK: string; notify_uuid: string }

const NotificationsNav = ({ user, unreadCount, isLoading }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)
  const theme = useTheme()
  const { mutate: updateNotifyItems } = useUpdateNotifyItems()
  const { markAsRead } = useUserNotifications()

  const handleOpenNotifications = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const updateNotificationsAsRead = (markedAsRead: Markable[]) => {
    if (!markedAsRead?.length) return
    const updates = markedAsRead.map(n => ({
      tableName: 'NOTIFICATIONS_TABLE',
      pkValue: n.PK,
      skValue: n.SK,
      primaryKey: 'PK',
      sortKey: 'SK',
      fieldName: 'isRead',
      newValue: true,
    }))
    // local provider + server
    markAsRead(markedAsRead.map(n => n.notify_uuid))
    updateNotifyItems({ updates })
  }

  const closeDrawer = (markedAsRead: Markable[]) => {
    setAnchorEl(null)
    updateNotificationsAsRead(markedAsRead)
  }

  return (
    <Box>
      {!user || isLoading ? (
        <CircularProgress size={20} />
      ) : (
        <Badge
          badgeContent={unreadCount > 0 ? unreadCount : null}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{
            '& .MuiBadge-badge': {
              top: 14,
              right: 10,
              fontSize: 12,
              fontWeight: 700,
              px: 0.8,
              bgcolor: 'rgb(60, 207, 169)',
              color: 'black',
              border: `1px solid ${theme.palette.mode === 'dark' ? '#111' : '#fff'}`,
            },
          }}
        >
          <IconButton
            onClick={handleOpenNotifications}
            sx={{
              minWidth: 48,
              minHeight: 48,
              borderRadius: 1.5,
              transition: 'transform 0.2s ease-in-out',
              '& .MuiSvgIcon-root': {
                color: 'text.primary',
                transition: 'color 0.2s ease-in-out',
              },
              '&:hover': {
                backgroundColor: 'transparent',
                transform: 'scale(1.2)',
                '& .MuiSvgIcon-root': {
                  color: 'text.highlight',
                },
              },
            }}
          >
            <NotificationsIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </Badge>
      )}

      {open && (
        <NotificationDrawer userId={user?.user_uuid} drawerOpen={open} closeDrawer={closeDrawer} anchorEl={anchorEl} />
      )}
    </Box>
  )
}
export default NotificationsNav

// import React, { useEffect, useState } from 'react'
// import { Box, Badge, IconButton, useTheme, CircularProgress } from '@mui/material'
// import NotificationsIcon from '@mui/icons-material/Notifications'
// import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone'
// import NotificationDrawer from '../../NotificationDrawer/NotificationDrawer'
// import { useUpdateMassItems } from '../../../api/aws/useUpdateMassItems'
// import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'
// import { useUserNotifications } from '../../../context/NotificationProvider/useUserNotifications'
// import { useUpdateNotifyItems } from '../../../api/aws/notifications/useUpdateNotifyItems'

// const NotificationsNav = ({ user, unreadCount, isLoading }) => {
//   const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
//   const open = Boolean(anchorEl)
//   const theme = useTheme()
//   const { mutate: updateNotifyItems } = useUpdateNotifyItems()
//   const { markAsRead } = useUserNotifications()

//   const handleOpenNotifications = (event: React.MouseEvent<HTMLElement>) => {
//     // Single source of truth: anchorEl
//     setAnchorEl(event.currentTarget)
//   }

//   // Expect an array of FULL notifications (with PK, SK, notify_uuid).
//   const updateNotificationsAsRead = async (
//     unreadNotifications: Array<{ PK: string; SK: string; notify_uuid: string }>
//   ) => {
//     if (!unreadNotifications?.length) return
//     const updates = unreadNotifications.map(n => ({
//       tableName: 'NOTIFICATIONS_TABLE',
//       pkValue: n.PK,
//       skValue: n.SK,
//       primaryKey: 'PK',
//       sortKey: 'SK',
//       fieldName: 'isRead',
//       newValue: true,
//     }))

//     // Optimistic local flag (if you keep one) + server update
//     markAsRead(unreadNotifications.map(n => n.notify_uuid))
//     updateNotifyItems({ updates })
//   }

//   // NOTE: `onClose` should hand back the *objects*, not just ids.
//   const closeDrawer = (unreadNotifications: Array<{ PK: string; SK: string; notify_uuid: string }>) => {
//     setAnchorEl(null)
//     if (unreadNotifications?.length) {
//       updateNotificationsAsRead(unreadNotifications)
//     }
//   }

//   return (
//     <Box>
//       {!user || isLoading ? (
//         <CircularProgress />
//       ) : (
//         <Badge
//           badgeContent={user ? (unreadCount > 0 ? unreadCount : null) : null}
//           anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//           sx={{
//             '& .MuiBadge-badge': {
//               top: 18,
//               right: 12,
//               fontSize: 15,
//               fontWeight: 'bold',
//               bgcolor: 'rgb(60, 207, 169)',
//               color: 'rgba(0,0,0,1)',
//             },
//           }}
//         >
//           <IconButton
//             onClick={handleOpenNotifications}
//             sx={{
//               minWidth: 50,
//               minHeight: 60,
//               borderRadius: 0,
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//             }}
//           >
//             <NotificationsIcon sx={{ height: 22, width: 22 }} />
//           </IconButton>
//         </Badge>
//       )}

//       {open && (
//         <NotificationDrawer userId={user?.user_uuid} drawerOpen={open} closeDrawer={closeDrawer} anchorEl={anchorEl} />
//       )}
//     </Box>
//   )
// }
// export default NotificationsNav
